<main class="price-lists-portal">
  <ng-container [ngSwitch]="currentViewMode">
    <ng-container *ngSwitchCase="ViewMode.SCREEN">
      <lx-price-lists-portal-price-lists-header [buttons]="screenModeButtons"></lx-price-lists-portal-price-lists-header>
      <div class="price-lists-portal__tabs-container">
        <p-tabView [(activeIndex)]="selectedTabIndex" (onChange)="onChangeTab()">
          <p-tabPanel header="Kaplan">
            <lx-price-lists-portal-price-lists [company]="CompanyEnum.KIL"></lx-price-lists-portal-price-lists>
          </p-tabPanel>
          <p-tabPanel header="Alpadia / Azurlingua" [class]="!priceListShowJuniorCamps ? 'price-lists-portal__tab-panel--junior-camps' : ''">
            <lx-price-lists-portal-price-lists [company]="CompanyEnum.ALP"></lx-price-lists-portal-price-lists>
          </p-tabPanel>
          <p-tabPanel header="Academic Year" *ngIf="priceListShowAya">
            <lx-price-lists-portal-academic-year-abroad></lx-price-lists-portal-academic-year-abroad>
          </p-tabPanel>
          <p-tabPanel header="Junior Camps" *ngIf="priceListShowJuniorCamps">
            <lx-price-lists-portal-junior-camps></lx-price-lists-portal-junior-camps>
          </p-tabPanel>
          <p-tabPanel header="Young Adults" *ngIf="priceListShowYoungAdults">
            <lx-price-lists-portal-young-adults></lx-price-lists-portal-young-adults>
          </p-tabPanel>
          <p-tabPanel header="Online Courses">
            <lx-price-lists-portal-online-courses></lx-price-lists-portal-online-courses>
          </p-tabPanel>
        </p-tabView>
      </div>
      <div class="price-lists-portal__footer">Kaplan Pricelist / {{ priceListArea$ | async }}</div>
    </ng-container>

    <ng-container *ngSwitchCase="ViewMode.PRINT">
      <lx-price-lists-portal-price-lists-header [buttons]="printModeButtons"></lx-price-lists-portal-price-lists-header>
      <lx-price-lists-portal-printable-price-lists></lx-price-lists-portal-printable-price-lists>
    </ng-container>
  </ng-container>
</main>
